import React from 'react';
import { ErrorsInterface } from './errorInput.types';
import { SelectedData } from '../redux/personalInfo.state';

export interface PersonPageProps {
  goTo: string;
}

export interface DataPersonInfoState {
  firstName: string;
  secondName: string;
  firstLastname: string;
  secondLastname: string;
  birthDate: string;
  rfc: string;
}

export interface PersonalFormComponentInterface {
  names: string;
  firstName: string;
  secondName: string;
  firstLastname: string;
  secondLastname: string;
  birthDate: string;
  rfc: string;
  phone: string;
  email: string;
  isLoading: boolean;
  errors?: ErrorsInterface;
  handleChangeInput: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleNamesChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: (event: React.ChangeEvent<HTMLButtonElement>) => void;
}

export interface PropertyState {
  name: string;
  value: string | Array<SelectedData> | SelectedData | number;
}
export enum EnumNamesInputs {
  NAMES = 'names',
  FIRST_NAME = 'firstName',
  SECOND_NAME = 'secondName',
  FIRST_LAST_NAME = 'firstLastname',
  SECOND_LAST_NAME = 'secondLastname',
  BIRTH_DATE = 'birthDate',
  RFC = 'rfc',
  PHONE_NUMBER = 'phone',
  EMAIL = 'email',
}
